import { BrowserModule } from '@angular/platform-browser';
import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AngularMarkdownEditorModule } from 'angular-markdown-editor';

import { AppRoutingModule } from './app-routing.module';
import { ViewsModule } from './views/views.module';
import { SharedModule } from './shared/shared.module';
import { ErrorModule } from './views/errors/error.module';
import { environment } from 'src/environments/environment';

// main layout
import { NavigationModule } from './main-layout/navigation/navigation.module';
import { GlobalHttpInterceptorServiceInterceptor } from './interceptors/global-http-interceptor-service.interceptor';

// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ProgressReportService } from './services/ui/progress-report.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    NavigationModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    ViewsModule,
    ErrorModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    MDBBootstrapModule.forRoot(),
    RecaptchaV3Module,
  ],
  providers: [
    ProgressReportService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptorServiceInterceptor,
      multi: true,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.reCaptchaKey,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
